<script lang="ts">
    import {bunkTypes, type Payments, type Registration} from "@shared/Types.ts";
    import {type PricingInfo, renderPricingInfo} from "@shared/calculate-cost.ts";
    import {toFixed} from "@shared/Utils.ts";
    import Warnings from "./Warnings.svelte";

    export let r: Registration;
    export let pricingInfo: PricingInfo;
    export let payments: Payments;
    export let unconfirm: any;
</script>

<article>
    {#if payments.waitlist}
        <div class="alert alert-success">
            Your waitlist registration is confirmed!
            <br>
            <small>Don't think you should be on the waitlist? Please contact woballsouls@gmail.com!</small>
        </div>
    {:else}
        <div class="alert alert-success">Your registration is confirmed!</div>
    {/if}
    <button on:click={unconfirm}>Edit your registration</button>
    <h3>Your Registration Details:</h3>
    <h4>Part 1: Who are you</h4>
    <div style="overflow-x: auto;">
        <table>
            <tr><td>Email</td><td>{r.email}</td></tr>
            <tr><td>First Name</td><td>{r.firstName}</td></tr>
            <tr><td>Last Name</td><td>{r.lastName}</td></tr>
            <tr><td>Phone Number</td><td>{r.phoneNumber}</td></tr>
            <tr><td>Preferred Contact Method</td><td>{r.preferredContactMethod}</td></tr>
        </table>
    </div>
    <h4>Part 2: Who is coming?</h4>
    <div style="overflow-x: auto;">
        <table>
            <thead>
            <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Age</th>
                <th>RE</th>
                <th>Adult</th>
                <th>Veg</th>
                <th>Vegan</th>
                <th>GF</th>
                <th>DF</th>
            </tr>
            </thead>
            <tbody>
            {#each (r?.attendees ?? []) as attendee}
                <tr>
                    <td>{attendee.firstName}</td>
                    <td>{attendee.lastName}</td>
                    <td>{attendee.ageOnApril24}</td>
                    <td>{attendee.registeredForRE ? 'Yes' : 'No'}</td>
                    <td>{attendee.responsibleAdult}</td>
                    <td>{attendee.vegetarian ? 'Yes' : 'No'}</td>
                    <td>{attendee.vegan ? 'Yes' : 'No'}</td>
                    <td>{attendee.glutenFree ? 'Yes' : 'No'}</td>
                    <td>{attendee.dairyFree ? 'Yes' : 'No'}</td>
                </tr>
            {/each}
            </tbody>
        </table>
    </div>
    {#if r.additionalDietaryNeeds}
        <p><strong>Additional Dietary Needs:</strong> {r.additionalDietaryNeeds}</p>
    {/if}

    <h4>Part 3: Sleeping Arrangements</h4>
    <table>
        <tr><td>Choice</td><td>{bunkTypes[r.sleepingArrangementChoice] ?? r.sleepingArrangementChoice}</td></tr>
        {#if r.cabinSharing}
            <tr><td>Cabin Sharing</td><td>{r.cabinSharing}</td></tr>
        {/if}
        {#if r.sleepingArrangementsComments}
            <tr><td>Comments</td><td>{r.sleepingArrangementsComments}</td></tr>
        {/if}
    </table>

    <h4>Part 4: Additional Accommodations & Ability to Pay</h4>
    <table>
        {#if r.registrationComments}
            <tr><td>Comments</td><td>{r.registrationComments}</td></tr>
        {/if}
        {#if r.rideSharing}
            <tr><td>Ride Sharing</td><td>{r.rideSharing}</td></tr>
        {/if}
        <tr><td>Ability to Pay</td><td>{r.abilityToPay}</td></tr>
        {#if r.waiverReason}
            <tr><td>Waiver Reason</td><td>{r.waiverReason}</td></tr>
        {/if}
        {#if r.donationAmount && r.abilityToPay === 'I can pay more than my fair share'}
            <tr><td>Donation Amount</td><td>${toFixed(r.donationAmount, 2)}</td></tr>
        {/if}
    </table>

    <h4>Part 5: Participant Waiver</h4>
    <table>
        <tr><td>Accepted</td><td>{r.liabilityWaiverAccepted ? 'Yes' : 'No'}</td></tr>
        <tr><td>Accepted By</td><td>{r.liabilityWaiverAcceptedBy}</td></tr>
    </table>

    {#if !payments.waitlist}
        <h4>Part 6: Registration Fees</h4>
        {@html renderPricingInfo(r, pricingInfo, payments)}

        <h4>Part 7: Payment History</h4>
        <p>We can provide full refunds (minus transaction fees) through March 23rd.  Partial refunds will be available March 23rd through April 9th.   Unfortunately we can not provide refunds after April 9th.  Please plan accordingly. </p>
        <table>
            <thead>
            <tr>
                <th>Amount</th>
                <th>Date</th>
            </tr>
            </thead>
            <tbody>
            {#each payments?.payments ?? [] as payment}
                <tr>
                    <td style="text-align: center;">{payment.amount === 0 ? 'free confirmation' : ('$' + toFixed(payment.amount, 2))}</td>
                    <td style="text-align: center;">{new Date(payment.date).toLocaleString()}</td>
                </tr>
            {:else}
                <tr>
                    <td colspan="2" style="text-align: center;">No payments yet.</td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        <h4>Waitlist Confirmation</h4>
        <p>Your waitlist registration has been received. You will be contacted if you move off the waitlist. Please watch your email for updates.</p>
    {/if}
</article>